<template>
  <span>
    <span v-if="invoiceCycle && invoiceDay">
      <span> {{ kpStr }} </span>
      <el-popover
        placement="bottom"
        title="开票节点"
        width="200"
        trigger="hover"
        :content="kpjdStr"
      >
        <img slot="reference" src="~assets/icons/info.svg" class="tag-icon" />
      </el-popover>
    </span>
    <span v-else>-</span>
  </span>
</template>
<script>
export default {
  name: '',
  props: {
    invoiceCycle: Number,
    invoiceDay: Number,
    invoiceTrigger: [String, Number]
  },
  computed: {
    kpStr() {
      const { invoiceCycle = 0, invoiceDay = 0 } = this
      if (invoiceCycle && invoiceDay) {
        return (invoiceCycle == 1 ? '当月' : '隔月') + invoiceDay + '日开票'
      }
      return ''
    },
    kpjdStr() {
      const { invoiceTrigger = 0, invoiceCycle = 0, invoiceDay = 0 } = this
      if (!invoiceDay) return '商家开具发票。'
      let str = ''
      if (invoiceTrigger === 1 || invoiceTrigger === '付款完成') {
        str = `买方于当月${invoiceDay}日前付款完成，`
      } else if (invoiceTrigger === 2 || invoiceTrigger === '货物交割结算') {
        str = `买卖双方于当月${invoiceDay}日前完成货物交割及结算，`
      }
      let kpStr = invoiceCycle === 1 ? '当月' : '隔月'
      str += invoiceCycle ? `商家于${kpStr}可开票。` : '商家开具发票。'
      return str
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.inner-wrapper {
  display: inline-flex;
  align-items: center;
}
.tag-icon {
  width: 14px;
  height: 14px;
  top: 3px;
  position: relative;
}
</style>
